export const isProduction = DEPLOY_ENV === 'master';

// noinspection JSUnresolvedVariable
export const ZT_ROOT_ADDRESS = isProduction ? '//ws.xoyo.com' : '//test-ws.xoyo.com';

// noinspection JSUnresolvedVariable
export const PASSPORT_ROOT_ADDRESS = isProduction ? '//pf-api.xoyo.com/passport/common_api' : '//my-api-dev.xoyo.com/passport/common_api';

// noinspection JSUnresolvedVariable
export const PASSPORT_USER_ROOT_ADDRESS = isProduction ? '//pf-api.xoyo.com/passport/user_api' : '//my-api-dev.xoyo.com/passport/user_api';

// noinspection JSUnresolvedVariable
export const CAPTCHA_PRE_AUTH = isProduction ? '//pf-api.xoyo.com/passport/common_api/pre_auth' : '//my-api-dev.xoyo.com/passport/common_api/pre_auth';

// noinspection JSUnresolvedVariable
export const CAPTCHA_ZT_PRE_AUTH = DEPLOY_ENV === 'master' ? '//ws.xoyo.com/core/captcha/pre_auth' : '//test-ws.xoyo.com/core/captcha/pre_auth';

/**
 * 是否开启 mock
 * @type {boolean}
 */
export const IS_MOCK_ON = false;



// WEBPACK FOOTER //
// ./src/constants/index.js